import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useCreateBillingPortalSession } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Divider } from '@tribeplatform/react-ui-kit/Divider'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { useCurrentProductInformation } from '../hooks/useCurrentProductInformation.js'

export const BillingInformationCard = () => {
  const { $t } = useI18n()
  const { mutateAsync: createPortalSession } = useCreateBillingPortalSession()
  const { hasPlan } = useCurrentProductInformation()

  const goToPortalSession = async () => {
    const newWindow = window.open()
    try {
      const { url } = await createPortalSession({
        returnUrl: window.location.href,
      })
      newWindow.location.href = url
    } catch (e) {
      newWindow.close()
      toast({
        title: $t({
          defaultMessage: 'Something went wrong',
          id: 'Admin.Billing.BillingPortal.Error',
        }),
        description: $t({
          defaultMessage: 'Unable to open billing portal',
          id: 'Admin.Billing.BillingPortal.ErrorDescription',
        }),
        status: 'error',
      })
    }
  }

  if (!hasPlan) {
    return null
  }

  return (
    <Card>
      <Card.Header
        title={
          <T
            defaultMessage="Billing information"
            id="Admin.Billing.BillingInformation"
          />
        }
        description={
          <T
            defaultMessage="Manage your billing information."
            id="Admin.Billing.BillingInformationDescription"
          />
        }
      />
      <Card.Content>
        <Divider padding="none" className="-mx-6 mb-6" />
        <div className="flex flex-col gap-3">
          <Link onClick={goToPortalSession}>
            <T
              defaultMessage="Invoice history"
              id="Admin.Billing.BillingInformationCard.InvoiceHistory"
            />
          </Link>
          <Link onClick={goToPortalSession}>
            <T
              defaultMessage="Update payment method"
              id="Admin.Billing.BillingInformationCard.UpdatePaymentMethod"
            />
          </Link>
          <Link onClick={goToPortalSession}>
            <T
              defaultMessage="Update billing address"
              id="Admin.Billing.BillingInformationCard.UpdateBillingAddress"
            />
          </Link>
          <Link onClick={goToPortalSession}>
            <T
              defaultMessage="Cancel subscription"
              id="Admin.Billing.BillingInformationCard.CancelSubscription"
            />
          </Link>
        </div>
      </Card.Content>
    </Card>
  )
}
